<?php

Namespace View ;

class RegisterView extends \Core\View {

    public function display($data) {
        $tplfunc = \Core\View::$template ;
        $tpl_data = \Core\View::parse_view_template($tplfunc) ;
        \Core\View::execute_view_template('#template', $tpl_data) ;
    }

}


// WEBPACK FOOTER //
// app/Register/View/RegisterView.php